/** @module Sourcing/AggregateSRSuppliers */
define([
    "dojo/_base/declare",
    "csi/locale",
    "csi/widget/MessageDialog",
    "./AggregateSRTSuppliers"
], function(declare,locale,MessageDialog,AggregateSRTSuppliers) {

    return declare(AggregateSRTSuppliers, {

        /**
         * @override
         *
         * Display a confirmation message when changing supplier if data package is supplier specific
         */
        _hasToConfirmAction: function() {
            var node = this.getParent();
            return node.LineItems && node.LineItems.length > 0 ;
        },

        /**
         * @override
         *
         * Prompt confirmation with buttons “Ok” and “Cancel”.
         */
        confirmAction: function(params) {
            params = params || {};
            params.title = locale.resource("ChangeDPTemplateOrSuppliers_Title");
            params.message = locale.resource("ChangeDPTemplateOrSuppliers_Warning");
            params.buttons = [MessageDialog.BUTTON_CHANGE, MessageDialog.BUTTON_CANCEL];
            this.inherited(arguments);
        },

        /**
         * @override
         *
         * Continue if confirmed
         */
        onConfirm: function(/*String*/key) {
            if (key == MessageDialog.BUTTON_CANCEL) {
                this.postProcess();
            } else {
                AggregateSRTSuppliers.prototype.publish.call(this);
            }
        },

        /**
         * @override
         *
         * Confirm action if it is supplier specific supplier request
         */
        publish: function() {
            if (this._hasToConfirmAction()) {
                this.confirmAction({});
            } else {
                this.inherited(arguments);
            }
        }

    });
});